import ShopPage from './ShopPage';

export default ShopPage;
